import { validatePropertyValues } from './api';
import { getErrorMessage } from './getErrorMessage';
import { INVALID, UNKNOWN, VALID } from '../PropertyValidationStatus';
const validateWithProposedRules = ({
  validationRulesOverride,
  value,
  property
}, httpClient) => {
  return httpClient.post('property-validation/v1/property-validation/evaluate-proposed-rules', {
    data: {
      proposedRules: validationRulesOverride,
      proposedValue: value,
      propertyType: property.type
    }
  });
};
const getValidationStatus = maybeValidationResponse => {
  // The API returns no result sometimes when a property is valid, as long as
  // it's a 200 it means the property was valid
  if (!maybeValidationResponse) {
    return VALID;
  }
  if (maybeValidationResponse.isValid) {
    return VALID;
  }
  return INVALID;
};
const getErrors = (validationRequest, maybeValidationResponse) => {
  if (!maybeValidationResponse) {
    return [];
  }
  if (maybeValidationResponse.isValid === false) {
    return [getErrorMessage(maybeValidationResponse, validationRequest.property, validationRequest.objectTypeId)];
  }
  return [];
};
const createValidationResult = (validationAPIResponses, validationRequest) => {
  // BE maps property names to placeholder names when dealing with preview validation
  // https://git.hubteam.com/HubSpot/PropertyValidation/blob/master/PropertyValidationCore/src/main/java/com/hubspot/property/validation/core/PreviewValidationRequestIF.java#L39
  const propertyNamePlaceholderForPreviewValidation = () => {
    switch (validationRequest.property.type) {
      case 'date':
        return 'hs_preview_validation_not_a_real_date_property';
      case 'datetime':
        return 'hs_preview_validation_not_a_real_datetime_property';
      default:
        return 'hs_preview_validation_not_a_real_property';
    }
  };
  const propertyNameToMatch = validationRequest.validationRulesOverride ? propertyNamePlaceholderForPreviewValidation() : validationRequest.property.name;
  const maybeValidationResponse = validationAPIResponses.find(validationResponse => validationResponse.name === propertyNameToMatch);
  const validationStatus = getValidationStatus(maybeValidationResponse);
  const errors = getErrors(validationRequest, maybeValidationResponse);
  return {
    errors,
    validationRequest,
    validationStatus
  };
};
export const inboundDbPropertyValidator = (validationRequest, httpClient) => {
  // Short circuit if the value is not provided since it is always valid (all
  // properties can be cleared)
  if (validationRequest.value === undefined || validationRequest.value === null || validationRequest.value === '') {
    return Promise.resolve({
      errors: [],
      validationRequest,
      validationStatus: VALID
    });
  }

  // If we have validation rules override, use the evaluate-proposed-rules endpoint
  if (validationRequest.validationRulesOverride && validationRequest.validationRulesOverride.length > 0) {
    return validateWithProposedRules(validationRequest, httpClient).then(apiResponse => {
      return createValidationResult(apiResponse, validationRequest);
    }).catch(() => {
      return {
        errors: [],
        validationRequest,
        validationStatus: UNKNOWN
      };
    });
  }

  // Otherwise, use the standard validation endpoint
  return validatePropertyValues([{
    name: validationRequest.property.name,
    value: validationRequest.value
  }], httpClient, validationRequest.objectTypeId, validationRequest.objectId).then(apiResponse => {
    return createValidationResult(apiResponse, validationRequest);
  }).catch(() => {
    return {
      errors: [],
      validationRequest,
      validationStatus: UNKNOWN
    };
  });
};